import { CountResponseDto, MinimalTarget } from '@/generated/model';
import { getTargets, getTargetCount, getTargetCountExtended } from '@/generated/client/targets/targets';
import { db, norm, localCacheFilled } from './initDb';

export async function searchTargetsByNameFragment(
  nameFragment: string,
  offset = 0,
  pagesize = 20,
  order: string,
  tachographFilter?: boolean
): Promise<MinimalTarget[]> {
  if (!localCacheFilled()) {
    console.log('remote search');
    const response = await getTargets({
      filter: nameFragment,
      offset,
      limit: pagesize,
      order,
      TachographFilter: tachographFilter ?? false,
    });

    return response.data;
  }

  console.log('local search');
  try {
    const query = db.vehicle
      .where('normalizedName')
      .startsWith(norm(nameFragment))
      .or('description')
      .startsWith(nameFragment);

    // TODO ez nem jo, lasd
    // https://dexie.org/docs/Collection/Collection.offset()#paged-or-queries
    if (order === 'desc') {
      query.reverse();
    }

    return query.offset(offset).limit(pagesize).sortBy('normalizedName');
  } catch (error) {
    console.error('Flexible search failed:', error);
    return [];
  }
}

export async function dbToArray(
  offset: number,
  limit: number,
  order: string,
  tachographFilter?: boolean
): Promise<MinimalTarget[]> {
  if (!localCacheFilled()) {
    const response = await getTargets({
      filter: undefined,
      offset,
      limit,
      order,
      TachographFilter: tachographFilter ?? false,
    });

    return response.data;
  }

  try {
    if (order === 'desc') {
      return db.vehicle.orderBy('normalizedName').reverse().offset(offset).limit(limit).toArray();
    }

    return await db.vehicle.orderBy('normalizedName').offset(offset).limit(limit).toArray();
  } catch (error) {
    console.error('Failed to fetch data from Dexie:', error);
    return [];
  }
}

export async function getVehicleCountByFilter(
  filter: string | undefined,
  selectedIds: number[],
  tachographFilter?: boolean
): Promise<CountResponseDto> {
  const localFilter = filter === undefined ? '' : filter;
  if (!localCacheFilled()) {
    const response = await getTargetCountExtended(
      { filter: localFilter, ids: selectedIds },
      { tachographFilter: tachographFilter ?? false }
    );
    return response.data;
  }

  const targetList = await db.vehicle
    .where('normalizedName')
    .startsWith(norm(localFilter))
    .or('description')
    .startsWith(localFilter)
    .toArray();
  const count = targetList.length;
  const currentlySelectedIds = targetList.map((target) => target.id).filter((id) => selectedIds.includes(id));

  return { count, ids: currentlySelectedIds };
}

export async function getTotalVehicleCount(tachographFilter?: boolean): Promise<CountResponseDto> {
  const count = await getTotalVehicleCountNumber(tachographFilter);
  return { count, ids: [] };
}

async function getTotalVehicleCountNumber(tachographFilter?: boolean): Promise<number> {
  if (!localCacheFilled()) {
    const response = await getTargetCount({
      filter: '', // ez elvileg nullable de akkor elszall :( queryparamnak kellene lennie ?
      tachographFilter: tachographFilter ?? false,
    });

    return response.data;
  }

  return await db.vehicle.count();
}
